/** @type {(err: import("axios").AxiosError<{ error: boolean, errors: Array<{ message: string, name: string }>}>) => string} */
export const handleAxiosError = (err) => {
  const { response } = err
  if (response?.data?.errors?.length) {
    return response.data.errors[0].message
  }
  return 'Um erro inesperado aconteceu'
}
